<app-modal #modal customClassName="approve-patient-modal">
  <form class="modal-form-full-width" [formGroup]="form" (submit)="onSubmitForm()">
    <div class="modal-header">
      <h2 class="modal-title">Approve Patient</h2>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Patient ID</label>
        <input type="text" class="form-control" formControlName="patientCode">
      </div>
      <div class="form-group">
        <label>Site</label>
        <app-site-dropdown #siteSelect
          formControlName="siteId"
          [trialId]="form.value.trialId"
          [trialIdRequired]="true"
          [assignedOnly]="true"
          [unassignedOnly]="false"
          [approvedOnly]="true" />
      </div>

      <div class="patient-consent">
        <p class="consent-given" [class.visibility-hidden]="form.get('showPatientConsentCheckbox').value">
          <i class="far fa-check" aria-hidden="true"></i>
          Patient gave consent via the {{ form.get('patientConsentType').value }} on {{
            form.get('patientConsentDate').value | date: 'd MMM yyyy' }}
        </p>

        <div class="form-group" [class.visibility-hidden]="!form.get('showPatientConsentCheckbox').value">
          <label class="checkbox">
            <input type="checkbox" id="patientConsent" formControlName="patientConsent" value="true">
            <span></span>
          </label>
          <label class="checkbox-label" for="patientConsent">I confirm that I have seen and verified patient
            consent</label>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-6">
          <a (click)="reset()" class="btn btn-secondary" data-dismiss="modal">Cancel</a>
        </div>

        <div class="col-6">
          <button type="submit" class="btn btn-primary" [disabled]="!form.valid || isApprovalFormProcessing">
            @if (isApprovalFormProcessing) {
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span class="sr-only">Loading...</span>
            } @else {
              Approve
            }
          </button>
        </div>
      </div>
    </div>
  </form>
</app-modal>

<!-- Start: Merge Patient Modal -->
<app-modal #mergeModal customClassName="size-md">
  <div class="modal-header">
    <h2 class="modal-title">Merge Patient?</h2>
  </div>
  <div class="modal-body">
    <p style="margin-left: 15px; margin-right: 15px;">The patient code is already is use on this trial, would you like
      to merge this patient with the existing record?</p>

    <div class="patient-merge-details" *ngIf="patientApprovalCheck !== undefined && patientApprovalCheck !== null">
      <div class="row">
        <div class="col-12 col-lg-6">
          <h2>Existing Patient</h2>

          <label>Patient Name</label>
          <p>{{ patientApprovalCheck.existingPatientName }}</p>

          <label>Patient Email</label>
          <p>{{ patientApprovalCheck.existingPatientEmail }}</p>

          <label>Patient Code</label>
          <p>{{ patientApprovalCheck.existingPatientCode }}</p>

          <label>Trial Code</label>
          <p>{{ patientApprovalCheck.existingTrialCode }}</p>
        </div>

        <div class="col-12 col-lg-6">
          <h2>Approving Patient</h2>

          <label>Patient Name</label>
          <p>{{ patientApprovalCheck.approvingPatientName }}</p>

          <label>Patient Email</label>
          <p>{{ patientApprovalCheck.approvingPatientEmail }}</p>

          <label>Patient Code</label>
          <p>{{ form.get('patientCode').value }}</p>

          <label>Trial Code</label>
          <p>{{ patientApprovalCheck.approvingTrialCode }}</p>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-6">
            <a class="btn btn-outline" (click)="approvePatientNoMerge()">
              @if (isApprovalFormProcessing) {
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span class="sr-only">Loading...</span>
              } @else {
                No, Approve without merge
              }
            </a>
          </div>

          <div class="col-6">
            <a class="btn btn-primary" (click)="mergePatient()">
              @if (isApprovalFormProcessing) {
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span class="sr-only">Loading...</span>
              } @else {
                Yes, Merge
              }
            </a>
          </div>

        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <a class="btn btn-secondary" (click)="reset()" style="margin-top: 20px;">Cancel</a>
      </div>
    </div>
  </div>
</app-modal>
<!-- End: Merge Patient Modal -->
